"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.requestIdleCallbackOrTimeout = void 0;
const requestIdleCallbackOrTimeout = (fn, timeout) => {
    if (typeof requestIdleCallback !== 'undefined') {
        const config = timeout ? { timeout } : undefined;
        requestIdleCallback(fn, config);
    }
    else {
        setTimeout(fn, timeout || 1000);
    }
};
exports.requestIdleCallbackOrTimeout = requestIdleCallbackOrTimeout;
//# sourceMappingURL=requestIdleCallbackOrTimeout.js.map